export const integrationsDirectCdiJobsJobIdErrors = "/integrations/direct/cdi/jobs/:job_id/errors";
